<template>
  <div class="card-order box">
    <div class="column columns is-vcentered is-multiline">
      <div class="column is-full">
        <div class="id-row">
          <b-tag class="is-size-7" type="is-primary">
            WeServe Order ID: #{{ weserveID }}
          </b-tag>
          <b-button
            size="is-small"
            type="is-primary"
            outlined
            icon-pack="fas"
            icon-right="copy"
            @click.stop="copyToClipboard(weserveID, 'WeServe Order ID')"
          />
        </div>
        <div class="id-row">
          <b-tag class="is-size-7" type="is-info">
            Villa Order ID: #{{ villaID }}
          </b-tag>
          <b-button
            size="is-small"
            type="is-info"
            outlined
            icon-pack="fas"
            icon-right="copy"
            @click.stop="copyToClipboard(villaID, 'Villa Order ID')"
          />
        </div>
        <div v-if="orderCode" class="id-row">
          <b-tag class="is-size-7" type="is-light">
            Order Code: {{ orderCode }}
          </b-tag>
          <b-button
            size="is-small"
            outlined
            icon-pack="fas"
            icon-right="copy"
            @click.stop="copyToClipboard(orderCode, 'Order Code')"
          />
        </div>
      </div>
      <div class="column is-one-third">
        <b-tag
          style="height: 100%"
          class="column is-full is-size-6-mobile is-uppercase"
          :type="getStatusTagType()"
        >
          <div>Status:</div>
          <div class="has-text-weight-bold">{{ status }}</div>
        </b-tag>
      </div>
      <div class="column share-link-btn" @click.stop="onClickDetails">
        <b-button expanded type="is-link is-light" icon-pack="fas" icon-left="info-circle">
          View Details
        </b-button>
      </div>
    </div>
    <div class="column" style="text-align: center" v-if="cancelFlag">
      <b-button
        class="cancel-btn"
        type="is-danger"
        size="is-small"
        icon-pack="fas"
        icon-left="window-close"
        @click="onClickCancelOrderWeServe()"
      >
        Cancel WeServe Order
      </b-button>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  props: ["info", "villaID", "weserveID", "status", "orderCode", "updatedAt", "provinceName"],
  data() {
    return {
      description: false,
      timeoutInFiveMinuit: null,
      timeCancelOrder: dayjs(),
      tempTimeOut: 5 * 60, // min to sec
      timeStart: dayjs(),
      cancelFlag: false,
    };
  },
  mounted() {
    this.ableToCancelOrder();
  },
  methods: {
    getStatusTagType() {
      switch (this.status) {
        case "ORDER_MADE":
        case "ASSIGNING_DRIVER":
          return "is-warning is-light";
        case "DRIVER_ASSIGNED":
        case "DRIVER_ACCEPTED":
        case "ON_THE_WAY":
        case "ARRIVED":
          return "is-info is-light";
        case "PICKED_UP":
          return "is-primary is-light";
        case "COMPLETED":
          return "is-success is-light";
        case "CANCELLED":
        case "REJECTED":
          return "is-danger is-light";
        default:
          return "is-light";
      }
    },
    ableToCancelOrder() {
      switch (this.status) {
        case "ORDER_MADE":
        case "ASSIGNING_DRIVER": {
          this.cancelFlag = true;
          break;
        }
        case "DRIVER_ASSIGNED":
        case "DRIVER_ACCEPTED": {
          console.log("time diff", this.timeCancelOrder.diff(this.updatedAt, "second"));
          if (this.timeCancelOrder.diff(this.updatedAt, "second") >= this.tempTimeOut) {
            this.cancelFlag = false;
          } else {
            this.cancelOrderTimeOut();
            this.cancelFlag = true;
          }
          break;
        }
        default: {
          this.cancelFlag = false;
          break;
        }
      }
    },
    cancelOrderTimeOut() {
      console.log(
        "SET TIME OUT in",
        (this.tempTimeOut - this.timeCancelOrder.diff(this.updatedAt, "second")) * 1000
      );
      this.timeoutInFiveMinuit = setTimeout(() => {
        this.cancelFlag = false;
        this.clearCancelOrderTimeOut();
      }, (this.tempTimeOut - this.timeCancelOrder.diff(this.updatedAt, "second")) * 1000);
    },
    clearCancelOrderTimeOut() {
      clearTimeout(this.timeoutInFiveMinuit);
      console.log("CLEAR TIME OUT", typeof this.timeoutInFiveMinuit);
    },
    async onClickCancelOrderWeServe() {
      console.log("cancel order WeServe >>>", this.weserveID);
      
      this.$buefy.dialog.confirm({
        title: "Cancel WeServe Order",
        message: "Are you sure you want to cancel this WeServe order?",
        confirmText: "Cancel Order",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          try {
            const res = await this.$store.dispatch("weserve/cancelOrder", {
              id: this.weserveID,
              weserveOrderCode: this.orderCode,
              provinceName: this.provinceName || "phuket", // Use dynamic province or fallback
            });
            
            if (res.success) {
              this.$buefy.notification.open({
                message: `WeServe order cancelled successfully`,
                type: "is-success",
                duration: 5000,
                queue: false,
              });

              // Emit event to parent to refresh the order list
              this.$emit("order-cancelled", {
                weserveID: this.weserveID,
                villaID: this.villaID,
                orderCode: this.orderCode,
              });
            }
          } catch (error) {
            this.$buefy.notification.open({
              message: `Failed to cancel WeServe order: ${error.message}`,
              type: "is-danger",
              duration: 5000,
              queue: false,
            });
          }
        },
      });
    },
    onClickDetails() {
      this.$buefy.modal.open({
        parent: this,
        component: () => import("@/components/WeServeOrderDetailsModal"),
        props: {
          weserveOrderCode: this.orderCode,
          villaOrderID: this.villaID,
          provinceName: this.provinceName || "phuket"
        },
        hasModalCard: true,
        customClass: "modal-lg"
      });
    },
    async copyToClipboard(text, label) {
      try {
        // Use the Clipboard API if available
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(text);
        } else {
          // Fallback for older browsers
          const textArea = document.createElement("textarea");
          textArea.value = text;
          textArea.style.position = "fixed";
          textArea.style.left = "-999999px";
          textArea.style.top = "-999999px";
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          document.execCommand("copy");
          textArea.remove();
        }

        this.$buefy.toast.open({
          message: `${label} copied to clipboard!`,
          type: "is-success",
          duration: 2000,
          position: "is-top"
        });
      } catch (error) {
        console.error("Failed to copy:", error);
        this.$buefy.toast.open({
          message: "Failed to copy to clipboard",
          type: "is-danger",
          duration: 2000,
          position: "is-top"
        });
      }
    },
  },
  beforeDestroy() {
    if (this.timeoutInFiveMinuit) {
      this.clearCancelOrderTimeOut();
    }
  },
};
</script>

<style scoped>
.card-order {
  margin: 10px;
  padding: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.card-order:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.id-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.id-row .tag {
  flex: 1;
  justify-content: flex-start;
}

.id-row .button {
  flex-shrink: 0;
  min-width: 32px;
  transition: all 0.2s ease;
}

.id-row .button:hover {
  transform: scale(1.1);
}

.cancel-btn {
  margin-top: 10px;
}

.share-link-btn {
  cursor: pointer;
}
</style>